export const actionKeys = {
  fetchAppLanguages: 'cache/fetchAppLanguages',
  fetchCompanies: 'cache/fetchCompanies',
  fetchConsentFormFields: 'cache/fetchConsentFormFields',
  fetchEthnicities: 'cache/fetchEthnicities',
  fetchLanguages: 'cache/fetchLanguages',
  fetchCountries: 'cache/fetchCountries',
  fetchStates: 'cache/fetchStates',
  fetchIdTypes: 'cache/fetchIdTypes',
  fetchSkilledTrades: 'cache/fetchSkilledTrades',
  fetchCertificationTypes: 'cache/fetchCertificationTypes',
  fetchJobTitles: 'cache/fetchJobTitles',
  fetchTradeStatus: 'cache/fetchTradeStatus',
  fetchSocJobTitles: 'cache/fetchSocJobTitles',
  fetchLanguageTurnerProtocols: 'cache/fetchLanguageTurnerProtocols',
  fetchProjectRoles: 'cache/fetchProjectRoles',
};

export const actionKeysToLanguageSpecificLoaderKeyMap = {
  fetchAppLanguagesEn: 'fetchAppLanguagesEn',
  fetchAppLanguagesEs: 'fetchAppLanguagesEs',
  fetchCompaniesEn: 'fetchCompaniesEn',
  fetchCompaniesEs: 'fetchCompaniesEs',
  fetchConsentFormFieldsEn: 'fetchConsentFormFieldsEn',
  fetchConsentFormFieldsEs: 'fetchConsentFormFieldsEs',
  fetchEthnicitiesEn: 'fetchEthnicitiesEn',
  fetchEthnicitiesEs: 'fetchEthnicitiesEs',
  fetchLanguagesEn: 'fetchLanguagesEn',
  fetchLanguagesEs: 'fetchLanguagesEs',
  fetchCountriesEn: 'fetchCountriesEn',
  fetchCountriesEs: 'fetchCountriesEs',
  fetchStatesEn: 'fetchStatesEn',
  fetchStatesEs: 'fetchStatesEs',
  fetchIdTypesEn: 'fetchIdTypesEn',
  fetchIdTypesEs: 'fetchIdTypesEs',
  fetchSkilledTradesEn: 'fetchSkilledTradesEn',
  fetchSkilledTradesEs: 'fetchSkilledTradesEs',
  fetchCertificationTypesEn: 'fetchCertificationTypesEn',
  fetchCertificationTypesEs: 'fetchCertificationTypesEs',
  fetchJobTitlesEn: 'fetchJobTitlesEn',
  fetchJobTitlesEs: 'fetchJobTitlesEs',
  fetchTradeStatusEn: 'fetchTradeStatusEn',
  fetchTradeStatusEs: 'fetchTradeStatusEs',
  fetchSocJobTitlesEn: 'fetchSocJobTitlesEn',
  fetchSocJobTitlesEs: 'fetchSocJobTitlesEs',
  fetchLanguageTurnerProtocolsEn: 'fetchLanguageTurnerProtocolsEn',
  fetchLanguageTurnerProtocolsEs: 'fetchLanguageTurnerProtocolsEs',
  fetchProjectRolesEn: 'fetchProjectRolesEn',
  fetchProjectRolesEs: 'fetchProjectRolesEs',
};

export const actionKeyToLoaderKeyMap = {
  [actionKeys.fetchAppLanguages]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchAppLanguagesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchAppLanguagesEs,
  },
  [actionKeys.fetchCompanies]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchCompaniesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchCompaniesEs,
  },
  [actionKeys.fetchConsentFormFields]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchConsentFormFieldsEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchConsentFormFieldsEs,
  },
  [actionKeys.fetchEthnicities]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchEthnicitiesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchEthnicitiesEs,
  },
  [actionKeys.fetchLanguages]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchLanguagesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchLanguagesEs,
  },
  [actionKeys.fetchCountries]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchCountriesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchCountriesEs,
  },
  [actionKeys.fetchStates]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchStatesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchStatesEs,
  },
  [actionKeys.fetchIdTypes]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchIdTypesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchIdTypesEs,
  },
  [actionKeys.fetchSkilledTrades]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchSkilledTradesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchSkilledTradesEs,
  },
  [actionKeys.fetchCertificationTypes]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchCertificationTypesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchCertificationTypesEs,
  },
  [actionKeys.fetchJobTitles]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchJobTitlesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchJobTitlesEs,
  },
  [actionKeys.fetchTradeStatus]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchTradeStatusEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchTradeStatusEs,
  },
  [actionKeys.fetchSocJobTitles]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchSocJobTitlesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchSocJobTitlesEs,
  },
  [actionKeys.fetchLanguageTurnerProtocols]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchLanguageTurnerProtocolsEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchLanguageTurnerProtocolsEs,
  },
  [actionKeys.fetchProjectRoles]: {
    en: actionKeysToLanguageSpecificLoaderKeyMap.fetchProjectRolesEn,
    es: actionKeysToLanguageSpecificLoaderKeyMap.fetchProjectRolesEs,
  },
};

export const actionMapForDataLoaders = {
  fetchProjects: 'cache/fetchProjects',
  fetchWhitelistedProjects: 'cache/fetchWhitelistedProjects',
  fetchProjectDetails: 'cache/fetchProjectDetails',
  fetchProjectSettings: 'cache/fetchProjectSettings',
  fetchWorkerProfileCustomFields: 'cache/fetchWorkerProfileCustomFields',
  fetchWorkerProfileFieldsForAllCompanies: 'cache/fetchWorkerProfileFieldsForAllCompanies',
  fetchWorkerProjects: 'workerData/fetchWorkerProjects',
  fetchWorkerCourses: 'workerData/fetchWorkerCourses',
  fetchCompaniesEn: 'cache/fetchCompanies/en',
  fetchCompaniesEs: 'cache/fetchCompanies/es',
  fetchEthnicitiesEn: 'cache/fetchEthnicities/en',
  fetchEthnicitiesEs: 'cache/fetchEthnicities/es',
  fetchLanguagesEn: 'cache/fetchLanguages/en',
  fetchLanguagesEs: 'cache/fetchLanguages/es',
  fetchCountriesEn: 'cache/fetchCountries/en',
  fetchCountriesEs: 'cache/fetchCountries/es',
  fetchStatesEn: 'cache/fetchStates/en',
  fetchStatesEs: 'cache/fetchStates/es',
  fetchIdTypesEn: 'cache/fetchIdTypes/en',
  fetchIdTypesEs: 'cache/fetchIdTypes/es',
  fetchProjectRolesEn: 'cache/fetchProjectRoles/en',
  fetchProjectRolesEs: 'cache/fetchProjectRoles/es',
  fetchSkilledTradesEn: 'cache/fetchSkilledTrades/en',
  fetchSkilledTradesEs: 'cache/fetchSkilledTrades/es',
  fetchCertificationTypesEn: 'cache/fetchCertificationTypes/en',
  fetchCertificationTypesEs: 'cache/fetchCertificationTypes/es',
  fetchConsentFormFieldsEn: 'cache/fetchConsentFormFields/en',
  fetchConsentFormFieldsEs: 'cache/fetchConsentFormFields/es',
  fetchConsentAgreements: 'cache/fetchConsentAgreements',
  fetchJobTitlesEn: 'cache/fetchJobTitles/en',
  fetchJobTitlesEs: 'cache/fetchJobTitles/es',
  fetchTradeStatusEn: 'cache/fetchTradeStatus/en',
  fetchTradeStatusEs: 'cache/fetchTradeStatus/es',
  fetchSocJobTitlesEn: 'cache/fetchSocJobTitles/en',
  fetchSocJobTitlesEs: 'cache/fetchSocJobTitles/es',
  fetchLanguageTurnerProtocolsEn: 'cache/fetchLanguageTurnerProtocols/en',
  fetchLanguageTurnerProtocolsEs: 'cache/fetchLanguageTurnerProtocols/es',
};

export const actionMapForOtherLoaders = {
  authenticateUser: 'user/authenticateUser',
  authenticateUserInAdminSession: 'user/authenticateUserInAdminSession',
  createWorker: 'onboarding/createWorker',
  updateWorker: 'onboarding/updateWorker',
  searchWorker: 'onboarding/searchWorker',
  createPassword: 'onboarding/createPassword',
  acceptBiometricConsent: 'onboarding/acceptBiometricConsent',
  uploadImageToS3: 'onboarding/uploadImageToS3',
  uploadImagesToS3: 'onboarding/uploadImagesToS3',
  uploadProfilePicture: 'onboarding/uploadProfilePicture',
  fetchWorkerDetails: 'onboarding/fetchWorkerDetails',
  uploadGovernmentDocumentFiles: 'onboarding/uploadGovernmentDocumentFiles',
  deleteGovernmentDocumentFile: 'onboarding/deleteGovernmentDocumentFile',
  fetchCertificationGroups: 'onboarding/fetchCertificationGroups',
  fetchAllCertifications: 'onboarding/fetchAllCertifications',
  fetchMyCertifications: 'workerData/fetchMyCertifications',
  fetchRequiredCertifications: 'workerData/fetchRequiredCertifications',
  fetchWorkerDrugTestingSchedules: 'workerData/fetchWorkerDrugTestingSchedules',
  createWorkerDrugTestingSchedule: 'workerData/createWorkerDrugTestingSchedule',
  updateWorkerDrugTestingSchedule: 'workerData/updateWorkerDrugTestingSchedule',
  deleteWorkerDrugTestingSchedule: 'workerData/deleteWorkerDrugTestingSchedule',
  fetchWorkerThirdPartyDrugTestResults: 'workerData/fetchWorkerThirdPartyDrugTestResults',
  createWorkerThirdPartyDrugTestResult: 'workerData/createWorkerThirdPartyDrugTestResult',
  updateWorkerThirdPartyDrugTestResult: 'workerData/updateWorkerThirdPartyDrugTestResult',
  deleteWorkerThirdPartyDrugTestResult: 'workerData/deleteWorkerThirdPartyDrugTestResult',
  assignWorkerToCompanies: 'onboarding/assignWorkerToCompanies',
  assignExistingWorkerToCompanies: 'onboarding/assignExistingWorkerToCompanies',
  deleteCertification: 'onboarding/deleteCertification',
  addCertification: 'onboarding/addCertification',
  getCertificationDetails: 'onboarding/getCertificationDetails',
  updateCertification: 'onboarding/updateCertification',
  addMyCertification: 'workerData/addMyCertification',
  updateMyCertification: 'workerData/updateMyCertification',
  deleteMyCertification: 'workerData/deleteMyCertification',
  uploadSignatureToS3: 'onboarding/uploadSignatureToS3',
  submitConsentAcceptances: 'onboarding/submitConsentAcceptances',
  acceptCustomConsentForms: 'onboarding/acceptCustomConsentForms',
  fetchWorkerConsentAcceptances: 'onboarding/fetchWorkerConsentAcceptances',
  acceptProject: 'onboarding/acceptProject',
  declineProject: 'cache/declineProject',
  fetchAppLanguagesEn: 'cache/fetchAppLanguages/en',
  fetchAppLanguagesEs: 'cache/fetchAppLanguages/es',
  logoutUser: 'user/logoutUser',
  resetPassword: 'user/resetPassword',
  confirmResetPassword: 'user/confirmResetPassword',
  validateResetPasswordToken: 'user/validateResetPasswordToken',
  sendOtp: 'user/sendOtp',
  verifyOtp: 'user/verifyOtp',
  sendPinForPiiVerification: 'onboarding/sendPinForPiiVerification',
  verifyPiiPin: 'onboarding/verifyPiiPin',
  fetchWorkerExistingConsentForms: 'onboarding/fetchWorkerExistingConsentForms',
  fetchConsentFormInformation: 'workerData/fetchConsentFormInformation',
  downloadConsentFormPdf: 'workerData/downloadConsentFormPdf',
  fetchEmailContacts: 'workerData/fetchEmailContacts',
  fetchPhoneContacts: 'workerData/fetchPhoneContacts',
  addContact: 'workerData/addContact',
  removeContact: 'workerData/removeContact',
  makePrimaryContact: 'workerData/makePrimaryContact',
  verifyContact: 'workerData/verifyContact',
  fetchBadgePdf: 'cache/fetchBadgePdf',
  getWorkerRequirementStatus: 'onboarding/getWorkerRequirementStatus',
  fetchAssignedCompanies: 'onboarding/fetchAssignedCompanies',
  getRevokeBadgeInfo: 'onboarding/getRevokeBadgeInfo',
  getPositiveDrugTestResults: 'onboarding/getPositiveDrugTestResults',
  getUserCompanies: 'user/getUserCompanies',
  initiateauth: 'user/intiateAuth',
  respondToAuthChallenge: 'user/respondToAuthChallenge',
  fetchProfileCustomFieldsConfig: 'workerData/fetchProfileCustomFieldsConfig',
  changePassword: 'user/changePassword',
  fetchWorkerCompaniesRequirements: 'workerData/fetchWorkerCompaniesRequirements',
};
